import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from 'firebase/firestore';

import firebaseInit from './firebase.index';

const app = firebaseInit();
const db = getFirestore(app);

class FirestoreReports {
  static async LoadByBusinessId(businessId) {
    try {
      const reportsCollection = [];
      const queryReports = query(
        collection(db, 'reports'),
        where('userId', '==', businessId)
      );

      const reportsSnapShot = await getDocs(queryReports);

      reportsSnapShot.forEach((snapshot) => {
        reportsCollection.push(snapshot.data());
      });
      return reportsCollection;
    } catch (error) {
      return null;
    }
  }

  static async LoadByFilterAndBusinessId(filter, businessId) {
    try {
      const reportCollections = [];

      const reportsRef = collection(db, 'reports');

      let dtMinesUm = new Date(new Date(filter.date));
      let dt = new Date(new Date().setHours(24));
      if (filter.dateStart !== undefined) {
        dtMinesUm = new Date(new Date(filter.dateStart));
      }

      if (filter.dateEnd !== undefined) {
        dt = new Date(new Date(filter.dateEnd).setHours(24));
      }

      const queryReportsByUserIdAndDate = query(
        reportsRef,
        where('userId', '==', businessId),
        where('createdAt', '>=', dtMinesUm),
        where('createdAt', '<=', dt)
      );

      const reportsSnapShot = await getDocs(queryReportsByUserIdAndDate);

      reportsSnapShot.forEach((snapshot) => {
        reportCollections.push(snapshot.data());
      });
      return reportCollections;
    } catch (error) {
      return null;
    }
  }
}
export default FirestoreReports;
